import { useHistory } from 'react-router-dom';
import { getInternalPath } from '../utils';
import { ROUTES } from '../data/consts';

export default () => {
  const history = useHistory();

  const isSearchPage = history.location.pathname === getInternalPath(ROUTES.SEARCH);
  const isSummaryPage = history.location.pathname === getInternalPath(ROUTES.SUMMARY);
  return { isSearchPage, isSummaryPage };
};
